// Where a click on an in-app notification leads, for the types that carry
// their own destination. Notifications are created server-side only.

/** Weekly "talento nuevo" notice for a saved search (DEV-74). */
export const SAVED_SEARCH_ALERT = "saved_search_alert";

/**
 * Results page of the saved search a new-talent notice is about, or null.
 * Built from the search id rather than trusting a stored URL.
 */
export const savedSearchAlertPath = (notification) => {
  const id = notification?.metadata?.scout_search_id;
  if (notification?.type !== SAVED_SEARCH_ALERT || typeof id !== "string" || !id) {
    return null;
  }
  return `/scout/searches/${encodeURIComponent(id)}`;
};
